<script lang="ts">
  import { humanFileSize } from "../helpers/utils";
  import Text from "./Text.svelte";

  export let id: string = "";
  export let label: string = "";
  export let accept: string = "";
  export let required: boolean = false;
  export let disabled: boolean = false;
  export let multiple: boolean = false;
  export let maxSize: number = 10 * 1024 * 1024; // 10Mb
  export let files: File[];
  export let onFilesSelected: (files: File[]) => void; // always return the full selected list

  let error: string = "";
  let inputElement: HTMLInputElement;

  function onChange() {
    if (!inputElement || !inputElement.files) {
      error = "Something went wrong, please try again later or contact support@rekki.com";
      return;
    }

    if (!areSizesValid(inputElement.files)) {
      error = `Some of your selected files are above the maximum size limit of ${humanFileSize(
        maxSize
      )}.`;
      return;
    }

    onFilesSelected([...Array.from(inputElement.files), ...files]);
  }

  function removeFile(name: string) {
    onFilesSelected(files.filter((f) => f.name !== name));
  }

  function areSizesValid(files: FileList) {
    for (let i = 0; i < files.length; i++) {
      if (files[i].size > maxSize) {
        return false;
      }
    }
    return true;
  }
</script>

<div class="container">
  <input
    {id}
    bind:this={inputElement}
    {accept}
    {multiple}
    type="file"
    {required}
    on:change={onChange}
    {disabled}
  />
  <label for={id}>
    <div class="icon-container">
      <img
        class="camera"
        src="static/assets/icons/camera.svg"
        alt="attach files"
        width={18}
        height={18}
      />
    </div>
  </label>

  <div class="selected-list">
    {#if files.length > 0}
      {#each files as f}
        <div class="file">
          <p>{f.name}</p>
          <button class="remove-file" on:click={() => removeFile(f.name)}>remove</button>
        </div>
      {/each}
    {/if}
  </div>

  {#if error}
    <div class="error">
      <div class="icon-container">
        <img src="static/assets/icons/icon-info.svg" alt="info" width={11} height={11} />
      </div>
      <div class="error-text">
        <Text ocd>{error}</Text>
      </div>
    </div>
  {/if}
</div>

<style>
  input {
    display: none;
  }
  label {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-radius: 4px;
    padding: 16px;
    background-color: var(--rekki-neutral-01);
    width: 70px;
    height: 48px;
  }
  .icon-container {
    display: flex;
    justify-content: center;
    width: 40px;
    padding: 10px;
    border-radius: 18px;
    background-color: #fff;
  }
  .error {
    background-color: var(--rekki-warning);
    margin-top: 8px;
    border-radius: 8px;
    padding: 9px 10px;
    display: flex;
    flex-direction: row;
  }
  .file {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 8px 0;
  }
  .file > p {
    margin: 0 12px 0 0;
  }
  .file > button {
    background: none;
    border: none;
    color: var(--rekki-neutral-03);
    text-decoration: underline;
  }
  .error-text {
    margin-top: 1px;
  }
</style>
